import DOMPurify from 'dompurify'

/**
 * Sanitize HTML produced by marked or other renderers before v-html.
 */
export function sanitizeHtml(html) {
  if (!html) return ''
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true }
  })
}

/** Rich CMS HTML: allow iframe embeds from http(s) only. */
export function sanitizeRichHtml(html) {
  if (!html) return ''
  const cleaned = DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_TAGS: ['iframe'],
    ADD_ATTR: [
      'allow',
      'allowfullscreen',
      'allowFullScreen',
      'frameborder',
      'scrolling',
      'src',
      'height',
      'width',
      'class',
      'style',
      'webkitallowfullscreen',
      'mozallowfullscreen'
    ]
  })
  // 嵌入页（如哔哩哔哩）尽量带上全屏权限；微信里仍可能被限制
  return cleaned.replace(/<iframe\b([^>]*)>/gi, (match, attrs) => {
    let next = attrs
    if (!/\ballowfullscreen\b/i.test(next)) {
      next += ' allowfullscreen'
    }
    if (!/\ballow\s*=/i.test(next)) {
      next += ' allow="fullscreen; picture-in-picture"'
    } else if (!/fullscreen/i.test(next)) {
      next = next.replace(/\ballow\s*=\s*(['"])(.*?)\1/i, (_, q, val) => `allow=${q}${val}; fullscreen${q}`)
    }
    return `<iframe${next}>`
  })
}
